// ** Icons Import
import {
  Mail,
  MessageSquare,
  CheckSquare,
  Calendar,
  FileText,
  Circle,
  ShoppingCart,
  User,
  Shield,
  File,
  ShoppingBag,
  Archive,
  Settings,
  MessageCircle,
  Users,
  Percent,
  Package,
  BarChart2
} from "react-feather"

export default [
  {
    id: "cases",
    title: "Cases",
    icon: <File size={20} />,
    navLink: "/cases"
  },
  {
    id: "reports",
    title: "Reports",
    icon: <BarChart2 size={20} />,
    navLink: "/reports",
    requiresReportsAccess: true
  },
  {
    id: "shop",
    title: "Shop",
    icon: <ShoppingBag size={20} />,
    navLink: "/shop",
    requiredRoles: ['admin', 'supervisor', 'doctor', 'clinic', 'partner', 'instructor', 'planner']
  },
  {
    id: "orders",
    title: "Orders",
    icon: <Package size={20} />,
    navLink: "/orders",
    requiredRoles: ['admin', 'supervisor', 'doctor', 'clinic', 'partner', 'instructor']
  },
  {
    id: "archive",
    title: "Archive",
    icon: <Archive size={20} />,
    navLink: "/archived"
  },
  {
    id: "settings",
    title: "Settings",
    icon: <Settings size={20} />,
    requiredRoles: ['admin', 'supervisor'],
    children: [
      {
        id: "general",
        title: "General",
        icon: <Settings size={12} />,
        navLink: "/settings/general",
        requiredRoles: ['admin', 'supervisor']
      },
      {
        id: "products",
        title: "Products",
        icon: <ShoppingBag size={12} />,
        navLink: "/settings/products",
        requiredRoles: ['admin', 'supervisor']
      },
      {
        id: "coupons",
        title: "Coupons",
        icon: <Percent size={12} />,
        navLink: "/settings/coupons",
        requiredRoles: ['admin', 'supervisor']
      },
      {
        id: "whatsapp",
        title: "WhatsApp",
        icon: <MessageCircle size={12} />,
        navLink: "/settings/whatsapp",
        requiredRoles: ['admin', 'supervisor']
      },
      {
        id: "users",
        title: "Users",
        icon: <Users size={12} />,
        navLink: "/settings/users",
        requiredRoles: ['admin']
      }
    ]
  }
  // {
  //   header: 'Apps & Pages'
  // },
  // {
  //   id: 'email',
  //   title: 'Email',
  //   icon: <Mail size={20} />,
  //   navLink: '/apps/email'
  // },
  // {
  //   id: 'chat',
  //   title: 'Chat',
  //   icon: <MessageSquare size={20} />,
  //   navLink: '/apps/chat'
  // },
  // {
  //   id: 'todo',
  //   title: 'Todo',
  //   icon: <CheckSquare size={20} />,
  //   navLink: '/apps/todo'
  // },
  // {
  //   id: 'calendar',
  //   title: 'Calendar',
  //   icon: <Calendar size={20} />,
  //   navLink: '/apps/calendar'
  // },
  // {
  //   id: 'kanban',
  //   title: 'Kanban',
  //   icon: <CheckSquare size={20} />,
  //   navLink: '/apps/kanban'
  // },
  // {
  //   id: 'invoiceApp',
  //   title: 'Invoice',
  //   icon: <FileText size={20} />,
  //   children: [
  //     {
  //       id: 'invoiceList',
  //       title: 'List',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/invoice/list'
  //     },
  //     {
  //       id: 'invoicePreview',
  //       title: 'Preview',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/invoice/preview'
  //     },
  //     {
  //       id: 'invoiceEdit',
  //       title: 'Edit',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/invoice/edit'
  //     },
  //     {
  //       id: 'invoiceAdd',
  //       title: 'Add',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/invoice/add'
  //     }
  //   ]
  // },

  // {
  //   id: 'roles-permissions',
  //   title: 'Roles & Permissions',
  //   icon: <Shield size={20} />,
  //   children: [
  //     {
  //       id: 'roles',
  //       title: 'Roles',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/roles'
  //     },
  //     {
  //       id: 'permissions',
  //       title: 'Permissions',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/permissions'
  //     }
  //   ]
  // },
  // {
  //   id: 'eCommerce',
  //   title: 'eCommerce',
  //   icon: <ShoppingCart size={20} />,
  //   children: [
  //     {
  //       id: 'shop',
  //       title: 'Shop',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/ecommerce/shop'
  //     },
  //     {
  //       id: 'detail',
  //       title: 'Details',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/ecommerce/product-detail'
  //     },
  //     {
  //       id: 'wishList',
  //       title: 'Wish List',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/ecommerce/wishlist'
  //     },
  //     {
  //       id: 'checkout',
  //       title: 'Checkout',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/ecommerce/checkout'
  //     }
  //   ]
  // },
  // {
  //   id: 'users',
  //   title: 'User',
  //   icon: <User size={20} />,
  //   children: [
  //     {
  //       id: 'list',
  //       title: 'List',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/user/list'
  //     },
  //     {
  //       id: 'view',
  //       title: 'View',
  //       icon: <Circle size={12} />,
  //       navLink: '/apps/user/view'
  //     }
  //   ]
  // }
]
